<template>
  <div class="panel-body">
    <h4 v-if="showUsers.Message">Message: {{ showUsers.Message }}</h4>
    <h1 class="logo-desc">Programming Hub</h1>
    
    <!--================ ALERT ==================-->
    <div class="alert alert-success alert-dismissible" v-if="showData.resetPasswordMsg">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong>Success!</strong> new password has been sent to your email...
    </div>
    <!--================ ALERT ENDS =================-->
    <!--================== SEARCH BOX =================-->
    <div class="customWidth">
      <form @submit.prevent="getUser">
        <div>
          <label for="usr">Email:</label>
          <input type="email" class="form-control" v-model="searchUser" placeholder="enter email">
        </div>
        <br>
        <button type="submit" class="btn btn-primary">Search</button>
      </form>
    </div>
    <br>
    <!--================== SEARCH BOX ENDS=================-->
    <!--================== USER CARD=================-->
    <triangle-loader v-if="loader" />
    <div class="container containerUserCard" v-if="showData.searchedUserData">
      <br>
      <div>
        <strong>User ID:</strong>
        {{showData.searchedUserData.user_id}}
      </div>
      <br>
      <div class="row">
        <div class="col-md-2">
          <!-- image -->
          <img :src="showData.searchedUserData.profile_pics" alt="Image Not Found...">
        </div>
        <div class="col-md-10 text-left">
          <!-- content -->
          <strong>Name:</strong>
          {{showData.searchedUserData.user_name}}
          <br>
          <strong>Email:</strong>
          {{showData.searchedUserData.email_id}}
          <br>
          <strong>Email Verified:</strong>
          {{showData.searchedUserData.email_verified}}
          <br>
          <strong>Sign-in Mode:</strong>
          {{showData.searchedUserData.signin_mode}}
          <br>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary" @click="resetPassword">Reset Password</button>
      </div>
      <br>
    </div>
    <!--================== USER CARD ENDS=================-->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
Vue.use(VueLoaders);
export default {
  name: "tabulardata",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      showData: "showData",
      showUsers: "showUsers",
      showMessage: "showMessage",
      loader: "showLoader"
    }),
    searchUser: {
      set: function(val) {
        this.$store.commit("updateSearchUser", val);
      },
      get: function() {
        return this.showData.searchUser;
      }
    }
  },
  mounted() {
    // this.getUser();
    this.modeSet();
  },
  methods: {
    ...mapActions(["searchUser_", "setMode", "resetPassword_"]),
    getUser: function() {
      this.searchUser_({
        mode: this.showData.mode
      });
      this.searchUser = null;
    },
    modeSet: function() {
      this.setMode({ mode: this.showData.mode });
    },
    resetPassword: function() {
      this.resetPassword_({ mode: this.showData.mode });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-desc {
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 0.6px;
  text-align: center;
  color: #494949;
  padding: 14px 0px 14px 18px;
}
.customWidth {
  text-align: center;
  width: 30%;
  margin: 0 auto;
}
.containerUserCard {
  margin: 0 auto;
  width: 50%;
  background: #f0eded;
  border-radius: 5px;
}
img {
  border-radius: 5px;
}
</style>
